// CMS Technical Reference Architecture conformance.
//
// Lives under TRM rather than Cyber: seven of the thirteen principles are scored
// from the technical reference model itself — products, versions, categories,
// documented alternatives, consolidation. It touches cyber posture, but it is an
// architecture-standards concern and belongs where the estate standards live.
import React from "react";
import { TraConformance } from "../../pages/CyberTabs";

export default function TraConformancePage() {
  return (
    <div style={{ padding: 20 }}>
      <h1 style={{ fontSize: 22, fontWeight: 700, color: "var(--cares-text-1)", margin: "0 0 4px" }}>
        CMS TRA Conformance
      </h1>
      <p style={{ fontSize: 13, color: "var(--cares-text-label)", margin: "0 0 18px", maxWidth: 760 }}>
        The estate scored against the thirteen CMS Technical Reference Architecture
        foundation principles, from records this platform already holds. Where a
        principle cannot be fully evidenced, the missing field is named.
      </p>
      <TraConformance />
    </div>
  );
}
